import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Inject, InjectionToken, Injector } from '@angular/core';
import { AdalService } from './adal.service';
import { catchError, mergeMap, switchMap, timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppLoaderService } from '../../services/app-loader/app-loader.service';
import swal from 'sweetalert2';
import { LicensePortalProduct, ProductClientSecret } from '../interfaces/LicenseModel';
import { config } from '../../config';
export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private adalService: AdalService, @Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number, private inj: Injector, private authService: AuthService,  private appLoaderService: AppLoaderService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    if (req.url.includes(config.TokenGenerationUrl + "connect/token") || req.url.includes('user/getuserdata')) {
      return next.handle(req).pipe(
        timeout(timeoutValueNumeric),
        catchError((err: any) => {
          this.handleAzureADError(err);
          return Observable.throw(err);
        }))
    }
    else if (req.url.includes('DownloadZipFile') || req.url.includes('VerifySCAL360OTPVerification') || req.url.includes("GetSoftwareUpdates") || req.url.includes('SendEmailToSCAL360Customer') || req.url.includes('get-ip') || req.url.includes('generate-sas-token') || req.url.includes('AddSoftwareDownloadDetails')) {
      return this.authService.access_token().pipe(
        switchMap((token) => {
          const JWT = `Bearer ${token.access_token}`;
          req = req.clone({
            setHeaders: {
              Authorization: JWT,
            },
          });
          return next.handle(req)
            .pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }));
    }
    else if(req.url.includes('LZ30AdvertisementDetails') || req.url.includes('LZ30UserDetails')|| req.url.includes('LZ30LicenseDetails') || req.url.includes('Faq')){
      return this.authService.access_token_license(LicensePortalProduct.LZ30,ProductClientSecret.LZ30).pipe(
        switchMap((token)=>{
            const JWT=`Bearer ${token.access_token}`;
            req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            });
            return next.handle(req)
            .pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
          }))
    }
    else if(req.url.includes('SmartLink360LicenseDetails')){
      return this.authService.access_token_license(LicensePortalProduct.SmartLink360,ProductClientSecret.SmartLink360).pipe(
        switchMap((token)=>{
          const JWT=`Bearer ${token.access_token}`;
          req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            })
            return next.handle(req).pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }))
    }
    else if(req.url.includes('Service360LicenseDetails')){
      return this.authService.access_token_license(LicensePortalProduct.Service360,ProductClientSecret.Service360).pipe(
        switchMap((token)=>{
          const JWT=`Bearer ${token.access_token}`;
          req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            })
            return next.handle(req).pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }))
    }
    else if(req.url.includes('ProductLicenseDetails') || req.url.includes('ProductPurchaseDetails') || req.url.includes('ProductActivationDetails') || req.url.includes('ProductRenewalDetails') || req.url.includes('Operations')){
      return this.authService.access_token_license(LicensePortalProduct.SCAL,ProductClientSecret.SCAL).pipe(
        switchMap((token)=>{
          const JWT=`Bearer ${token.access_token}`;
          req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            })
            return next.handle(req).pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }))
    }
    else if(req.url.includes('SmartCal360NLicenseDetail')){
      return this.authService.access_token_license(LicensePortalProduct.SmartCal360N,ProductClientSecret.SmartCal360N).pipe(
        switchMap((token)=>{
          const JWT=`Bearer ${token.access_token}`;
          req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            })
            return next.handle(req).pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }))
    }    
     else if(req.url.includes('SyncIT')){
      return this.authService.access_token_license(LicensePortalProduct.SYNCIt,ProductClientSecret.SyncIT).pipe(
        switchMap((token)=>{
          const JWT=`Bearer ${token.access_token}`;
          req=req.clone({
              setHeaders:{
                Authorization: JWT
              }
            })
            return next.handle(req).pipe(
              catchError((err: any) => {
                this.handleIdentityServerToken(err);
                return Observable.throw(err);
              }))
        }))
    }
    else {
      return this.adalService.acquireTokenResilient("75db915c-344c-4e36-a5f2-20925770c15b")
        .pipe(mergeMap((token) => {
          if (token) {
            req = req.clone({
              setHeaders: {
                Authorization: 'Bearer ' + token,
              },
            });
          }
          return next.handle(req)
            .pipe(
              catchError((err: any) => {
                this.handleAzureADError(err);
                return Observable.throw(err);
              }))
        }))
    }
  }
  handleIdentityServerToken(err) {
    if (err.status == 404) {
      swal.fire("Warning", "The Client was unable to connect the API " + err.url, 'warning');
      this.appLoaderService.close();
    }
    else if (err.status == 500) {
      swal.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
      this.appLoaderService.close();
    }
    else if (err.status == 401) {
      swal.fire("Warning", "UnAuthorized Token..!", "warning");
      this.appLoaderService.close();
    }
    else {
      this.appLoaderService.close();
      swal.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
    }
  }
  handleAzureADError(err) {
    if (err.status == 404) {
      this.appLoaderService.close();
      swal.fire("Warning", "The Client was unable to connect the API " + err.url, 'warning');
    }
    else if (err.status == 500) {
      swal.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
    }
    else if (err.status == 401) {
      this.appLoaderService.close();
      window.close();
      window.location.href = "/login";
    }
    else {
      this.appLoaderService.close();
      swal.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
    }
  }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/auth-interceptor.ts